export const currencyFormatter = new Intl.NumberFormat('da-DK', {
  style: 'currency',
  currency: 'DKK'
})

export const numberFormatter = new Intl.NumberFormat('da-DK', {})
